import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { useFact } from "@/lib/factoryI18n";
import { exportCsv } from "@/lib/csv";

export default function StockOnHand() {
  const { lang } = useLang();
  const f = useFact(lang);
  const [rows, setRows] = useState([]);
  const [stage, setStage] = useState("");
  const [source, setSource] = useState("");
  useEffect(() => { api.get("/factory/stock-on-hand").then((r) => setRows(r.data)); }, []);
  const filtered = rows.filter((r) => (!stage || r.stage === stage) && (!source || r.source_type === source));
  const total = filtered.reduce((a, r) => a + r.count, 0);
  const totalSqft = filtered.reduce((a, r) => a + (r.sq_ft || 0), 0);

  return (
    <div data-testid="stock-on-hand">
      <h1 className="text-2xl font-bold mb-4" style={{ color: "var(--brand-navy)", fontFamily: "'Fraunces', serif" }}>{f("stock_on_hand")}</h1>
      <div className="flex flex-wrap gap-2 mb-3 items-center">
        <select data-testid="stock-filter-stage" value={stage} onChange={(e) => setStage(e.target.value)} className="h-9 px-2 border border-[#1B3A5C]/15 rounded-md text-sm">
          <option value="">All stages</option>
          {["Received", "Post-Weave QC", "Finishing", "Post-Wash QC", "Final QC", "Ready for Despatch"].map((s) => <option key={s}>{s}</option>)}
        </select>
        <select data-testid="stock-filter-source" value={source} onChange={(e) => setSource(e.target.value)} className="h-9 px-2 border border-[#1B3A5C]/15 rounded-md text-sm">
          <option value="">All sources</option>
          {["Weaver delivery", "Trading vendor — FG", "Trading vendor — SF", "In-house manufacturing"].map((s) => <option key={s}>{s}</option>)}
        </select>
        <button data-testid="stock-export" onClick={() => exportCsv("stock_on_hand.csv", filtered)} className="h-9 px-3 rounded-md text-xs border border-[#1B3A5C]/20">Export CSV</button>
        <div className="ml-auto text-sm"><b data-testid="stock-total">{total}</b> pieces · <b>{Math.round(totalSqft)}</b> sq ft</div>
      </div>
      <table className="w-full text-sm bg-white border border-[#1B3A5C]/10 rounded-lg overflow-hidden">
        <thead>
          <tr className="text-left text-[10px] uppercase tracking-widest text-[#7C8E9E] border-b border-[#1B3A5C]/10">
            <th className="px-3 py-2">Stage</th><th>Design</th><th>Size</th><th>Source</th><th>Location</th><th className="text-right">Count</th><th className="text-right">Sq ft</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((r, i) => (
            <tr key={i} className="border-b border-[#1B3A5C]/5" data-testid={`stock-row-${i}`}>
              <td className="px-3 py-2">{r.stage}</td><td>{r.design_code}</td><td>{r.size_text}</td><td>{r.source_type}</td><td>{r.location}</td>
              <td className="text-right">{r.count}</td><td className="text-right">{Math.round(r.sq_ft || 0)}</td>
            </tr>
          ))}
          {filtered.length === 0 && <tr><td colSpan={7} className="px-3 py-6 text-center text-[#7C8E9E]">No stock.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
